import { connect } from 'react-redux';
import type { Props } from '../components/HealthNextSteps';
import HealthNextSteps from '../components/HealthNextSteps';
import {
  getSummary,
  getManagement,
} from '@/pages/CompanyReport/redux/selectors';
import { getPeople } from '@ducks/people/selectors';
import { get } from 'lodash';

type ContainerProps = {
  companyId?: string;
  isDataMeaningless: boolean;
};

const mapStateToProps = (
  state,
  { companyId, isDataMeaningless }: ContainerProps
): Props => {
  const summary = getSummary(state, { companyId });
  const management = getManagement(state, { companyId });
  const people = getPeople(state);
  const leader = people[management.leaderId];

  return {
    countryISO: summary.countryISO,
    isDataMeaningless,
    scorePast: summary.score.past,
    scoreValue: summary.score.value,
    companyName: summary.shortName,
    scoreFuture: summary.score.future,
    tickerSymbol: summary.tickerSymbol,
    scoreDividend: summary.score.income,
    CEOCompensation: get(leader, 'compensation', null),
    exchangeSymbol: summary.exchangeSymbol,
    industryPrimaryName: summary.industryData.primaryName,
  };
};

export default connect<Props, undefined, ContainerProps>(mapStateToProps)(
  HealthNextSteps
);
